import { render, staticRenderFns } from "./promptRemarks.vue?vue&type=template&id=c3c02066&scoped=true&"
import script from "./promptRemarks.vue?vue&type=script&lang=js&"
export * from "./promptRemarks.vue?vue&type=script&lang=js&"
import style0 from "./promptRemarks.vue?vue&type=style&index=0&id=c3c02066&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3c02066",
  null
  
)

export default component.exports